import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {
  ProcessFlowchartValidationError,
  ProcessFlowchartObjectType,
} from 'processes/graph-builder-processes/validation/ProcessFlowchartForValidationTypes';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

export interface ProcessFlowchartValidationErrorBannerProps {
  validationErrors: Array<ProcessFlowchartValidationError>;
}

/**
 * Banner that displays errors that are associated with the overall flowchart config (global errors).
 */
export default function ProcessFlowchartValidationErrorBanner({
  validationErrors,
}: ProcessFlowchartValidationErrorBannerProps): JSX.Element | null {
  const flowchartLevelErrors = validationErrors.filter(
    (error) => error.object?.type === ProcessFlowchartObjectType.FLOWCHART_CONFIG || error.object == null
  );

  if (flowchartLevelErrors.length === 0) {
    return null;
  }

  return (
    <div className={css(styles.bannerContainer)}>
      <InlineBanner
        bannerType={InlineBannerType.ERROR}
        text={flowchartLevelErrors.map((error) => error.errorMessage).join('\n')}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  bannerContainer: {
    position: 'absolute',
    top: '16px',
    left: '16px',
    zIndex: 1000,
    maxWidth: '800px',
    minWidth: '500px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    borderRadius: '4px',
  },
});
